/**
 * @desc 查询城市列表根据省份编码
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.RegionEncodingParameters): Promise<BaseResponse<defs.ResultBean<Array<defs.Area>>>> {
  return fetch({
    url: config.API_HOST + '/dict/findCityListByProvince',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
